import apiFetch from '../../apiFetch'

export default function (values, token) {
  return apiFetch({endPoint: `Microbiologia/getFiltrarMicrobiologia`, method: 'POST', body: values, token: token})
}
